import { connectToStores } from 'fluxible-addons-react';
import { QUANTUM_UI } from '../../../flags';
import ApplicationStore from '../../stores/ApplicationStore';
import { AuthDropdown } from './AuthDropdown';
import { AuthDropdown as AuthDropdownOld } from './AuthDropdown.old';
export default connectToStores(QUANTUM_UI ? AuthDropdown : AuthDropdownOld, [ApplicationStore], function (context) { return ({
    manageUrl: context.getStore(ApplicationStore).getDashboardUrl(),
}); });
